import { getParamByISO } from 'iso-country-currency';
const getCountryISO2 = require('country-iso-3-to-2');
export const formatCurrency = (currencyDetails) => {
    const { locale, amount } = currencyDetails;
    return amount.toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
};
export const getISO2CountryCode = (countryCode) => getCountryISO2(countryCode).toString();
export const getCurrencyISO3 = (countryCode) => {
    return getParamByISO(getISO2CountryCode(countryCode), 'symbol');
};
export function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
